////// Lib. //////
//////////////////

// ...

///// Utils. /////
//////////////////

// ...

// Event hdls. ///
//////////////////

// ...

///// Assets /////
//////////////////

const msgs = {
  start: ["init. marquee"],
  end: ["init. marquee", "init. success"],
};

// Method def. ///
//////////////////

export default function init_marquee() {
  //////////////////// Setup /////////////////////
  ////////////////////////////////////////////////

  const el_comp = this.element;
  const { wrpr_contentItems, contentItems } = this.ref;
  const { logs, dir, speed, pauseOnHover, itemGap } = this.options;
  if (logs) console.log(msgs.start[0]);

  ////////////// Marquee animation ///////////////
  ////////////////////////////////////////////////

  // Animation variables
  let animationId;
  let currentPosition = 0;
  let lastTime = 0;
  const movement = window.devicePixelRatio >= 2 ? 0.3 : 0.6;

  ////////////// Prep. ///////////////
  ////////////////////////////////////

  // Adjust wrapper width to actual content width
  // + store single content item width for reset calculation
  let w_content = 0;
  let w_contentItem = 0;
  const amt_items = contentItems.length;
  contentItems.forEach((el) => {
    const itemIndex = Array.from(contentItems).indexOf(el);
    const w_el = el.getBoundingClientRect().width;
    w_content += w_el;
    if (itemIndex < amt_items - 1) w_content += itemGap; // Add gap between items
    w_contentItem = w_el + itemGap / 2; // Store width of single content item (incl. half gap for proper reset)
  });
  el_comp.style.setProperty("--w-wrpr-content", `${w_content}px`);

  //////////// Animation /////////////
  ////////////////////////////////////

  function animate(ts) {
    if (lastTime === 0) lastTime = ts;
    lastTime = ts;

    if (dir === "left") {
      currentPosition -= movement;
      // Reset position when first content item is fully scrolled out
      if (Math.abs(currentPosition) >= w_contentItem) currentPosition = 0;
    } else {
      currentPosition += movement;
      // Reset position when scrolled back to start
      if (currentPosition >= w_contentItem) currentPosition = 0;
    }

    // Apply transform with hardware acceleration
    wrpr_contentItems.style.transform = `translate3d(${currentPosition}px, 0, 0)`;

    // Continue animation
    animationId = requestAnimationFrame(animate);
  }

  // Start animation
  animate();

  /////// Pause-on-hover impl. ///////
  ////////////////////////////////////

  if (pauseOnHover) {
    el_comp.addEventListener("mouseenter", () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
        animationId = null;
      }
    });

    el_comp.addEventListener("mouseleave", () => {
      if (!animationId) {
        lastTime = 0; // Reset timing
        animate();
      }
    });
  }

  // Store cleanup function for component destruction
  this.cleanup = () => {
    if (animationId) {
      cancelAnimationFrame(animationId);
      animationId = null;
    }
  };

  /////////////////// Conclude ///////////////////
  ////////////////////////////////////////////////

  if (logs) console.log(msgs.end[0], "→", msgs.end[1]);
}
